module.exports = __webpack_public_path__ + "media/img/medication-phone-344bac5993ce167ce55143262ab2bf0c.png";